import pluralize from '@lib/utilities/text/pluralize'

export interface FormatSearchResultsTitleParams {
  activeLocationLabel?: string
  conditionOrIntervention?: string
  isLoading?: boolean
  isPaid?: boolean
  searchResultsCount: number
}

export default function formatSearchResultsTitle({
  activeLocationLabel,
  conditionOrIntervention,
  isLoading = false,
  isPaid = false,
  searchResultsCount,
}: FormatSearchResultsTitleParams): string {
  if (isLoading) {
    return 'Loading Clinical Trials...'
  }

  if (searchResultsCount === 0) {
    return 'No Clinical Trials Found'
  }

  const trialType = conditionOrIntervention ?? 'Clinical'

  let location = 'Near You'
  if (activeLocationLabel) {
    location = `near ${activeLocationLabel}`
  }

  // Create array of components and filter out empty strings
  const titleParts = [
    searchResultsCount.toString(),
    trialType,
    isPaid ? 'Paid' : '',
    pluralize('Trial', searchResultsCount, { includeCount: false }),
    location,
  ].filter(Boolean)

  return titleParts.join(' ')
}
